import React from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box } from "@mui/material";

export default function ReportesScreen() {
  // Replace this URL with your actual Google Looker Studio dashboard URL
  const dashboardUrl = "https://lookerstudio.google.com/embed/reporting/b85552ca-e289-4af8-a739-9b4cd34ab08f/page/p_mne2b77gxd";

  return (
    <DashboardLayout>
      <Box
        sx={{
          width: "100%",
          height: "calc(100vh - 64px)", // Adjust based on your header height
          p: 2,
        }}
      >
        <iframe
          src={dashboardUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          title="Reportes Dashboard"
        />
      </Box>
    </DashboardLayout>
  );
}

